var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIxSfmix(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1132 341",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M836 201h4v41h-4z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M186 201h54v41h-54z",
    fill: "#b05ae1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100 49l-54 55h54zM240 104l-54-55v55z",
    fill: "#601293"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46 104h54v41H46z",
    fill: "#926ee2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100 145H46l54 56z",
    fill: "#70128b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M186 145v56h54z",
    fill: "#7c0f85"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47 242h-1l54 57v-57z",
    fill: "#8f0067"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M186 242v57l54-57z",
    fill: "#8e0083"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M101 49h-1v55h86V49z",
    fill: "#b6bcfc"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M101 145h-1v56h86v-56z",
    fill: "#cabdfc"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M101 242h-1v57h86v-57z",
    fill: "#d6a8fb"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99 208H46v34h54v-34z",
    fill: "#c95ac2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M186 104h54v33h-54z",
    fill: "#8389f0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M292 104h55v41h-55zM292 201v98h55v-98z",
    fill: "#4980f0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M419 49h-72v55h113V49z",
    fill: "#abc7fd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M347 104V49l-55 55z",
    fill: "#384da2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M347 145h72v56h-72z",
    fill: "#9dd0fd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M292 145h55v56h-55z",
    fill: "#4852a6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M486 104h56V49",
    fill: "#547124"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M487 104h-1v195h56V104z",
    fill: "#93c62f"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M582 104v195h55V104z",
    fill: "#b1c52e"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M675 49v55h55",
    fill: "#7c831f"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M675 104v195h55V104z",
    fill: "#dbda33"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M784 104h56V49",
    fill: "#cd5e13"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M836 104h-52v195h56V104z",
    fill: "#e89e26"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M949.1 145l-.1.1v55.8l.1.1h83.9v-56z",
    fill: "#e27f5c"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M894 201v98h55v-98.1l-27.4-27.8zM921.6 172.9l27.4-27.8V49h-55v96z",
    fill: "#db002b"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M921.6 172.9l.1.1-.1.1 27.4 27.8v-55.8z",
    fill: "#9e0027"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1060.1 173l27.6-28h.3V49h-55v96h.1zM1060.1 173l-26.4 28h-.7v98h55v-98h-.3z",
    fill: "#db002b"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1060.1 173l-27-28h-.1v56h.7z",
    fill: "#a20e00"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M921.6 173.1l.1-.1-.1-.1-.1.1z",
    fill: "#828282"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M637 49l-27.5 27.5L637 104h38V49z",
    fill: "#d6e54e"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M582 49h-40v55h40l27.5-27.5z",
    fill: "#d5e34d"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M582 104h55l-27.5-27.5z",
    fill: "#60741b"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxMTMyIDM0MSIgdmlld0JveD0iMCAwIDExMzIgMzQxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Im04MzYgMjAxaDR2NDFoLTR6IiBmaWxsPSJub25lIi8+PHBhdGggZD0ibTE4NiAyMDFoNTR2NDFoLTU0eiIgZmlsbD0iI2IwNWFlMSIvPjxwYXRoIGQ9Im0xMDAgNDktNTQgNTVoNTR6IiBmaWxsPSIjNjAxMjkzIi8+PHBhdGggZD0ibTI0MCAxMDQtNTQtNTV2NTV6IiBmaWxsPSIjNjAxMjkzIi8+PHBhdGggZD0ibTQ2IDEwNGg1NHY0MWgtNTR6IiBmaWxsPSIjOTI2ZWUyIi8+PHBhdGggZD0ibTEwMCAxNDVoLTU0bDU0IDU2eiIgZmlsbD0iIzcwMTI4YiIvPjxwYXRoIGQ9Im0xODYgMTQ1djU2aDU0eiIgZmlsbD0iIzdjMGY4NSIvPjxwYXRoIGQ9Im00NyAyNDJoLTFsNTQgNTd2LTU3eiIgZmlsbD0iIzhmMDA2NyIvPjxwYXRoIGQ9Im0xODYgMjQydjU3bDU0LTU3eiIgZmlsbD0iIzhlMDA4MyIvPjxwYXRoIGQ9Im0xMDEgNDloLTF2NTVoMSA4NXYtNTV6IiBmaWxsPSIjYjZiY2ZjIi8+PHBhdGggZD0ibTEwMSAxNDVoLTF2NTZoMSA4NXYtNTZ6IiBmaWxsPSIjY2FiZGZjIi8+PHBhdGggZD0ibTEwMSAyNDJoLTF2NTdoMSA4NXYtNTd6IiBmaWxsPSIjZDZhOGZiIi8+PHBhdGggZD0ibTk5IDIwOGgtNTN2MzRoNTMgMXYtMzR6IiBmaWxsPSIjYzk1YWMyIi8+PHBhdGggZD0ibTE4NiAxMDRoNTR2MzNoLTU0eiIgZmlsbD0iIzgzODlmMCIvPjxwYXRoIGQ9Im0yOTIgMTA0aDU1djQxaC01NXoiIGZpbGw9IiM0OTgwZjAiLz48cGF0aCBkPSJtMjkyIDIwMXY0MSA1N2g1NXYtNTctNDF6IiBmaWxsPSIjNDk4MGYwIi8+PHBhdGggZD0ibTQxOSA0OWgtNzJ2NTVoNzIgNDF2LTU1eiIgZmlsbD0iI2FiYzdmZCIvPjxwYXRoIGQ9Im0zNDcgMTA0di01NWwtNTUgNTV6IiBmaWxsPSIjMzg0ZGEyIi8+PHBhdGggZD0ibTM0NyAxNDVoNzJ2NTZoLTcyeiIgZmlsbD0iIzlkZDBmZCIvPjxwYXRoIGQ9Im0yOTIgMTQ1aDU1djU2aC01NXoiIGZpbGw9IiM0ODUyYTYiLz48cGF0aCBkPSJtNDg2IDEwNGg1NnYtNTUiIGZpbGw9IiM1NDcxMjQiLz48cGF0aCBkPSJtNDg3IDEwNGgtMXY0MSA1NiA0MSA1N2gxIDU1di01Ny00MS01Ni00MXoiIGZpbGw9IiM5M2M2MmYiLz48cGF0aCBkPSJtNTgyIDEwNHY0MSA1NiA0MSA1N2g1NXYtNTctNDEtNTYtNDF6IiBmaWxsPSIjYjFjNTJlIi8+PHBhdGggZD0ibTY3NSA0OXY1NWg1NSIgZmlsbD0iIzdjODMxZiIvPjxwYXRoIGQ9Im02NzUgMTA0djQxIDU2IDQxIDU3aDU1di01Ny00MS01Ni00MXoiIGZpbGw9IiNkYmRhMzMiLz48cGF0aCBkPSJtNzg0IDEwNGg1NnYtNTUiIGZpbGw9IiNjZDVlMTMiLz48cGF0aCBkPSJtODM2IDEwNGgtNTJ2NDEgNTYgNDEgNTdoNTIgNHYtNTctNDEtNTYtNDF6IiBmaWxsPSIjZTg5ZTI2Ii8+PHBhdGggZD0ibTk0OS4xIDE0NS0uMS4xdjU1LjhsLjEuMWg4My45di01NnoiIGZpbGw9IiNlMjdmNWMiLz48cGF0aCBkPSJtODk0IDIwMXY5OGg1NXYtOTguMWwtMjcuNC0yNy44eiIgZmlsbD0iI2RiMDAyYiIvPjxwYXRoIGQ9Im05MjEuNiAxNzIuOSAyNy40LTI3Ljh2LTk2LjFoLTU1djk2eiIgZmlsbD0iI2RiMDAyYiIvPjxwYXRoIGQ9Im05MjEuNiAxNzIuOS4xLjEtLjEuMSAyNy40IDI3Ljh2LTU1Ljh6IiBmaWxsPSIjOWUwMDI3Ii8+PHBhdGggZD0ibTEwNjAuMSAxNzMgMjcuNi0yOGguM3YtOTZoLTU1djk2aC4xeiIgZmlsbD0iI2RiMDAyYiIvPjxwYXRoIGQ9Im0xMDYwLjEgMTczLTI2LjQgMjhoLS43djk4aDU1di05OGgtLjN6IiBmaWxsPSIjZGIwMDJiIi8+PHBhdGggZD0ibTEwNjAuMSAxNzMtMjctMjhoLS4xdjU2aC43eiIgZmlsbD0iI2EyMGUwMCIvPjxwYXRoIGQ9Im05MjEuNiAxNzMuMS4xLS4xLS4xLS4xLS4xLjF6IiBmaWxsPSIjODI4MjgyIi8+PHBhdGggZD0ibTYzNyA0OS0yNy41IDI3LjUgMjcuNSAyNy41aDM4di01NXoiIGZpbGw9IiNkNmU1NGUiLz48cGF0aCBkPSJtNTgyIDQ5aC00MHY1NWg0MGwyNy41LTI3LjV6IiBmaWxsPSIjZDVlMzRkIi8+PHBhdGggZD0ibTU4MiAxMDRoNTVsLTI3LjUtMjcuNXoiIGZpbGw9IiM2MDc0MWIiLz48L3N2Zz4=";
export { SvgIxSfmix as ReactComponent };